/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `There was an error loading the breadcrumbs`
};

const fr_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur s'est produite lors du chargement du fil d'Ariane`
};

const de_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `Beim Laden der Breadcrumbs ist ein Fehler aufgetreten`
};

const es_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error al cargar las migas de pan.`
};

const it_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore durante il caricamento del breadcrumb`
};

const ar_error_loading_breadcrumbs23 = /** @type {(inputs: {}) => string} */ () => {
	return `حدث خطأ أثناء تحميل فتات الخبز`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const error_loading_breadcrumbs23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error_loading_breadcrumbs23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error_loading_breadcrumbs23", locale)
	if (locale === "en") return en_error_loading_breadcrumbs23(inputs)
	if (locale === "fr") return fr_error_loading_breadcrumbs23(inputs)
	if (locale === "de") return de_error_loading_breadcrumbs23(inputs)
	if (locale === "es") return es_error_loading_breadcrumbs23(inputs)
	if (locale === "it") return it_error_loading_breadcrumbs23(inputs)
	return ar_error_loading_breadcrumbs23(inputs)
};
export { error_loading_breadcrumbs23 as "ERROR_LOADING_BREADCRUMBS" }